import { Component, Input } from '@angular/core';

@Component({
  selector: 'app-pss-loading',
  imports: [],
  templateUrl: './pss-loading.component.html',
  styleUrl: './pss-loading.component.css'
})
export class PssLoadingComponent {
  @Input() text : string = 'กําลังตรวจสอบข้อมูล'
  @Input() detail: string = 'โปรดรอสักครู่ . . .'
}
